import React, { Component } from 'react';
import { Button, Icon, Tooltip } from 'antd';
import { connect } from 'react-redux';
import { CheckCircleFilled } from '@ant-design/icons';

import { CURRENT_PLAN_CLOUD_ICON, VERSION_TICK, MANAGE_SERVER_REGION_ICON, FLAG_SINGAPORE_ICON, FLAG_FR_ICON } from '../../config/media';
import { ManageWrapper } from './style';
import { Fragment } from 'react';
import LogsAndBackupModal from './LogsAndBackupModal';
import RegionModal from './RegionModal'

class Manage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isVisible: false,
            showAdvanced: false,
            regionModal: false
        }
    }

    componentDidMount() {
        if (this.props.exchange) {
            this.setState({ isVisible: this.props.exchange.is_setup });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(this.props.exchange) !== JSON.stringify(prevProps.exchange)) {
            this.setState({ isVisible: this.props.exchange.is_setup });
        }
    }

    handleToggle = (checked) => {
        this.props.handleOff(checked);
    };

    handleAdvanced = () => {
        this.setState({ showAdvanced: !this.state.showAdvanced });
    };

    handleRedirect = () => {
        this.props.handleCancel();
        this.props.history.push('/hosting?tab=4');
    };

    handleUpgrade = () => {
        this.props.history.push('/billing');
    }

    onHandleCancelRegionModal = (setStep) => {
        this.setState({ regionModal: false })
        setStep('')
    }

    render() {
        const { isVisible, showAdvanced, regionModal } = this.state;
        const {
            events,
            exchange,
            constant,
            handleVersion,
            handleRestart,
            // handleCustomize,
            handleTerminate,
            isLogs = false,
            isBackup = false,
            step,
            handleBackup,
            handleCancel,
            handleLogs,
            // handleOpen,
            isBackupDisabled,
            isLogsDisabled
        } = this.props;
        const isUpgrade = !!(exchange.version
            && constant.kitVersion !== exchange.version)
        // const repository = exchange.info && exchange.info.repository
        //     ? exchange.info.repository
        //     : {};
        const isEventProgressing = !!events.filter(evt => (evt.status === 1 || evt.status === 0)).length;

        const { is_running } = exchange;
        return (
            <ManageWrapper>
                {
                    !isVisible && <div className="main-container">
                        <div className='d-flex flex-container'>
                            <img
                                src={MANAGE_SERVER_REGION_ICON}
                                alt='manage-server-icon'
                                className='cloud-icon-normal'
                            />
                            <div className="main-title">
                                Server Region
                            </div>
                        </div>
                        <div className='go-live-wrapper region-wrapper'>
                            <div className='region-container'>
                                <div><CheckCircleFilled fill={'green'} /></div>
                                <p>Region :  </p>
                                <p>{exchange.region === 'SG' ?
                                    <div className='d-flex'>
                                        <img
                                            src={FLAG_SINGAPORE_ICON}
                                            alt='flag-singapore'
                                            className='flag-icon'
                                        />
                                        Singapore
                                    </div>
                                    : <div className='d-flex'>
                                        <img
                                            src={FLAG_FR_ICON}
                                            alt='flag-france'
                                            className='flag-icon'
                                        />
                                        France
                                    </div>
                                }</p>
                                <p onClick={() => this.setState({ regionModal: true })} className='change-text'>(Change)</p>
                            </div>
                        </div>
                    </div>
                }
                {
                    !isVisible ?
                        <div className="main-container">
                            <div className='d-flex flex-container'>
                                <img
                                    src={CURRENT_PLAN_CLOUD_ICON}
                                    alt='cloud-icon'
                                    className='cloud-icon-normal'
                                />
                                <div className="main-title">
                                    Cloud management
                                </div>
                            </div>
                            <div className='go-live-wrapper'>
                                <div className='text-content'>
                                    Once you've gone live you can manage your exchange.
                                </div>
                                <div className="btn-wrapper">
                                    <Button type="primary" onClick={this.props.handleLive} disabled={isEventProgressing}>Go live</Button>
                                </div>
                            </div>

                        </div> : null
                }
                <div className={isVisible ? 'sub-container' : 'sub-container disable'}>
                    {
                        isVisible ?
                            <div className='d-flex main-container cloud-container'>
                                <img
                                    src={CURRENT_PLAN_CLOUD_ICON}
                                    alt='cloud-icon'
                                    className='cloud-icon-normal'
                                />
                                <div className="main-title">
                                    Cloud management
                                </div>
                            </div> :
                            null
                    }

                    {is_running && <div className={is_running ? "sub-content-list" : "sub-content-list pt-0"}>
                        <div className='sub-content-region-container'>
                            <p>Server region:</p>
                            <p>{
                                exchange.region === 'SG' ?
                                    <div className='d-flex'>
                                        <img
                                            src={FLAG_SINGAPORE_ICON}
                                            alt='flag-singapore'
                                            className='flag-icon'
                                        />
                                        Singapore
                                    </div>
                                    : <div className='d-flex'>
                                        <img
                                            src={FLAG_FR_ICON}
                                            alt='flag-france'
                                            className='flag-icon'
                                        />
                                        France
                                    </div>
                            }</p>
                        </div>
                        <div className="sub-title">
                            Upgrade
                        </div>
                        <div className="d-flex">
                            <div className="exclamation-icon">
                                {isUpgrade
                                    ? <Icon type="exclamation-circle" style={{ fontSize: '32px', color: '#0000FF' }} />
                                    : <img src={VERSION_TICK} alt="tick" className="tick-img" />
                                }
                            </div>
                            <div>
                                {isUpgrade
                                    ? 'Apply the latest HollaEx Kit upgrade.'
                                    : 'Your exchange is up-to-date.'
                                }
                                {isUpgrade ? <div className="description">{`Current version HollaEx Kit v${exchange.version}`}</div> : ''}
                                <div className="description">
                                    {`Latest version HollaEx Kit v${constant.kitVersion}`}{' '}
                                    {isUpgrade
                                        ? <span className="link" onClick={handleVersion}>(apply upgrade)</span>
                                        : <span className="link" onClick={handleVersion}>(Rebuild & update)</span>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>}

                    {/* <div className="separator"></div> */}
                    <div className={is_running ? "" : "disable-content"}>
                        <div>
                            {/* <div className="sub-content-list">
                                <div className="sub-title">Logs</div>
                                <div>
                                    Click download logs and select the period of time you'd like to get the logs for
                                </div>
                                <div className="btn-container">
                                    <Button type="primary" disabled={false} onClick={() => handleOpen("logs")}>Download Logs</Button>
                                </div>
                            </div> */}
                            {/* <div className="separator"></div> */}
                            <div className="sub-content-list">
                                <div className="sub-title">Backup</div>
                                <div>
                                    Clicking the backup button below will get the latest backup of your database which will then be sent to your email.
                                </div>
                                <div className="btn-container">
                                    <Button type="primary" onClick={handleBackup} disabled={isBackupDisabled || false}>Backup Database</Button>
                                </div>
                            </div>
                        </div>
                        {/* <div className="separator"></div> */}
                        <div className="sub-content-list">
                            <div className="sub-title">Restart</div>
                            <div>
                                Restarting your exchange may help in fixing unknown issues and applying changes
                            </div>
                            <div className="btn-container">
                                <Button type="primary" onClick={handleRestart} disabled={isEventProgressing}>Restart</Button>
                            </div>
                        </div>
                    </div>
                    {/* <div className="separator"></div> */}
                    <div className={"show-advanced"}>
                        <span
                            className={showAdvanced
                                ? "close"
                                : "open"
                            }
                            onClick={this.handleAdvanced}
                        >
                            Show danger zone
                        </span>
                    </div>
                    {showAdvanced
                        ? <Fragment>
                            {/* <div className="sub-content-list">
                                <div className="sub-title">
                                    Custom kit git repo
                                </div>
                                <div>Apply your own custom GitHub repo</div>
                                <div>
                                    <span className="list-head">Current repo:</span>{' '}
                                    <span>
                                        {repository.url
                                            ? repository.url
                                            : 'Default'
                                        }
                                    </span>
                                </div>
                                <div>
                                    <span className="list-head">Custom repo branch:</span>{' '}
                                    <span>
                                        {repository.branch
                                            ? repository.branch
                                            : 'Default'
                                        }
                                    </span>
                                </div>
                                <div className="btn-container">
                                    <Button type="primary" onClick={handleCustomize}>Customize</Button>
                                </div>
                                <div>
                                    If you haven't given proper repo permission you can view{' '}
                                    <a target="blank" href="https://docs.hollaex.com/">how-to here.</a>
                                </div>
                            </div>
                            <div className="separator"></div> */}
                            <div className="sub-content-list danger-zone">
                                <div className="sub-title">Danger zone</div>
                                <div className="danger-waring-text">
                                    <Icon type="exclamation-circle" theme="filled" style={{ color: '#FF0000', marginRight: '5px' }} />
                                    Use only when advised by your exchange cloud provider.
                                </div>
                                <div className="exchange-state">
                                    <div className="exchange-state-title">Exchange state</div>
                                    {!is_running
                                        ? <div>Start your exchange below.</div>
                                        : <div>Stop your exchange below. Beware, stopping your exchange will render it inaccessible.</div>
                                    }
                                </div>
                                {!is_running
                                    ? <div className="btn-container">
                                        <Button type="primary" onClick={() => this.handleToggle(true)} disabled={isEventProgressing}>Start</Button>
                                    </div>
                                    : <div className="btn-container">
                                        <Button type="primary" className='orange-btn' onClick={() => this.handleToggle(false)} disabled={isEventProgressing}>Stop</Button>
                                    </div>
                                }
                                <div className={!is_running ? "btn-container d-flex" : "btn-container d-flex disable-content"}>
                                    <div
                                        className={
                                            isEventProgressing
                                                ? "d-flex align-center pointer disabled"
                                                : "d-flex align-center pointer"
                                        }
                                        onClick={handleTerminate}
                                    >
                                        <div className='terminate-wrapper'>
                                            <div>
                                                <span className="terminate-link">Terminate exchange</span>
                                                <Tooltip
                                                    placement="right"
                                                    overlayClassName="terminating-tooltip"
                                                    title="Terminating your exchange will permanently delete your exchange and all configurations. Use only when advised to do so by your cloud provider."
                                                >
                                                    <Icon type="question-circle" style={{ fontSize: '10px', color: '#ffffff', marginLeft: '5px' }} />
                                                </Tooltip>
                                            </div>
                                            <span className='terminate-content'>Termination is permeant. To proceed you’d need to stop your exchange first.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                        : null
                    }
                </div>
                {isLogs || isBackup
                    ? <LogsAndBackupModal
                        visible={isLogs || isBackup}
                        isLogs={isLogs}
                        step={step}
                        onCancel={handleCancel}
                        handleRedirect={this.handleRedirect}
                        handleLogs={handleLogs}
                        isLogsDisabled={isLogsDisabled}
                    />
                    : null
                }
                <RegionModal
                    visible={regionModal}
                    onCancel={this.onHandleCancelRegionModal}
                    exchange={exchange}
                    getExchange={this.props.getExchange}
                />
            </ManageWrapper>
        )
    }
}

const mapStateToProps = (state) => ({
    events: state.constant.events
});

export default connect(mapStateToProps)(Manage);
